import { render, staticRenderFns } from "./ContestField.vue?vue&type=template&id=6b0d135e"
import script from "./ContestField.vue?vue&type=script&lang=js"
export * from "./ContestField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports